import axios from 'axios'
import endpoints from '../../config/endpoints.config'

import swalMessages from '../../utils/swalMessages'

// const url = 'https://0ykjvb8z2d.execute-api.eu-west-3.amazonaws.com/dev/company/companies'

// const usersUrl = 'https://lzbe8e42h4.execute-api.eu-west-3.amazonaws.com/default/B2B/users'

const getCompanies = async (request, idToken) => {
    try {
        const [companies /* companyUsers */] = await Promise.all([
            axios.post(endpoints.b2b.companies, request,{
                headers: {
                    Authorization: idToken
                }
            }).then(({ data }) => data)
            // axios.get(usersUrl).then(({ data }) => data)
        ])
        // for (const company of companies.results) {
        //     company.pwd = companyUsers[company.CompanyName]
        // }
        //console.log('companies :>> ', companies)
        return companies
    } catch (error) {
        swalMessages.errorMessage(`get redirections failed: ${error.message}`)
    }
}
export default getCompanies
